import { useCallback } from 'react';
import { HttpMethod } from './fetch';
import { useFetch } from './use-fetch';

export type UploadImageProps = {
  /** web端上传参 */
  image?: File;
  /** 端内使用base64 */
  base64Image?: string;
  isInApp: boolean;
};

/**
 * 上传图片获取cdn的url
 * 返回url
 */
export const useFetchUploadImage = () => {
  const fetch = useFetch();

  return useCallback(async (props: UploadImageProps) => {
    const { isInApp, base64Image } = props;
    let image = props.image;

    let res;
    // 端内只能拿到图片的base64
    if (isInApp && base64Image) {
      try {
        const binaryString = atob(base64Image);
        const binaryData = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          binaryData[i] = binaryString.charCodeAt(i);
        }
        const blobData = new Blob([binaryData], { type: 'application/octet-stream' });
        image = new File([blobData], 'upload-file.jpg', { type: 'application/octet-stream' });
      } catch (err) {
        throw new Error('inapp image file error');
      }
    }

    if (image) {
      res = await fetch('https://heliophilia.lemon8-app.com/api/200/image/upload', {
        method: HttpMethod.post,
        isFormData: true,
        params: {
          image,
        },
      }).catch((err) => ({
        message: `error`,
        err,
      }));
    }

    if (res?.message === 'success') {
      return {
        url: res.data.url_list[0].url || '',
        uri: res.data.uri || '',
      };
    }

    throw new Error('image upload error');
  }, []);
};
